import "./LoadingSpinner.scss";

import { ReactComponent as Spinner } from "../../../assets/icons/loading.svg";
export default function LoadingSpinner() {
  return (
    <div className="spinner">
      <Spinner />
    </div>
  );
}
